import { isEmpty } from '../isEmpty/isEmpty';
import { isObject } from '../isObject/isObject';
/**
 * Allow to recursively update properties of objects.
 *
 * @param {Object} target Target object.
 * @param {Object} source Object with new or updated values.
 * @returns {Object}
 *
 * @example
 * // If target object is "{ a: 1 }" and source object is "{ a: 2, b: 2 }" , returns "{ a: 2, b: 2 }"
 * deepMerge({ a: 1 }, { a: 2, b: 2 });
 */
export function deepMerge(target, source) {
    const output = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach((key) => {
            if (isObject(source[key])) {
                if (!(key in target)) {
                    Object.assign(output, { [key]: source[key] });
                }
                else {
                    output[key] = deepMerge(target[key], source[key]);
                }
            }
            else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    if (isEmpty(target) && !isEmpty(source)) {
        return Object.assign({}, source);
    }
    return output;
}
